module.exports = __webpack_public_path__ + "static/af-developing-wildfire-preparedness-guide-2020-01-560ec5e0e6bf1f612b4a5e2f01615ca9.pdf";